<template>
<section :class="[block.class, {'half-padding-top': block.half_padding_top}, {'half-padding-bottom': block.half_padding_bottom}, 'section', block.bgcolour]" :id="block.anchor ? block.anchor : ('block-' + block.id)">
    <div class="container">
        <div class="columns is-variable is-6" v-if="!block.hide_title">
            <div class="column is-offset-4">
                <h2 :class="['title', block.title_colour]">{{block.title}}</h2>
            </div>
        </div>
        <div :class="['columns repeatable-row is-variable is-6', {'is-mobile': is_mobile}]" v-if="block.items && block.items.length > 0" v-for="item in block.items">
            <div class="column is-4">
                <figure v-if="item.image">
                    <img :alt="item.image.title" :src="item.image.url" />
                </figure>
            </div>
            <div class="column is-6">
                <h3 v-if="item.title" :class="['title', block.title_colour]">{{item.title}}</h3>
                <div class="content" v-if="item.content" ref="content" v-html="item.content"></div>
            </div>
        </div>
        <div class="columns">
            <div :class="['column', block.cta.config.alignment]">
                <div :class="['cta']" v-if="block.cta && block.cta.button">
                    <CTALink :link_data="block.cta" />
                </div>
            </div>
        </div>
    </div>
</section>
</template>

<script>
import BlockCommons from '../../mixins/BlockCommons';
import WindowResizeHandler from '../../mixins/WindowResizeHandler';
export default {
    name        :   'RepeatableImageContentBlock',
    mixins      :   [ BlockCommons, WindowResizeHandler ],
    data()
    {
        return {
            is_mobile   :   true
        }
    },
    mounted() {
        this.$nextTick().then(() => {
            if (this.$refs.content) {
                this.HandleContentedLinks(this.$refs.content, this)
            }
        })
    },
    methods     :   {
        handle_window_resize(width)
        {
            if (width >= 768) {
                this.is_mobile  =   true;
            } else{
                this.is_mobile  =   false;
            }
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/blocks/modules/RepeatableImageContentBlock.vue